class Lightbox {
	constructor(imgClass) {
		this.excludeClass = 'js-no-lightbox';
		this.gallery = '.ns-img-gallery';
		this.images = Array.prototype.slice.call( document.querySelectorAll(`${imgClass}:not(.${this.excludeClass})`));
		this.galleryImages = Array.prototype.slice.call(document.querySelectorAll(`${this.gallery} ${imgClass}:not(.${this.excludeClass})`));
		this.lightbox = document.querySelector('.js-lightbox');
		this.lightboxImgWrap = this.lightbox.querySelector('.lightbox-img-wrap');
		this.lightboxPrev = this.lightbox.querySelector('.lightbox__nav--prev');
		this.lightboxNext = this.lightbox.querySelector('.lightbox__nav--next');

		// document.querySelector("p").closest(".near.ancestor")

		this.bindEvents();
	}

  bindEvents(){
		this.images.forEach(img =>
      img.addEventListener('click', e => {
				if(this.galleryImages.includes(img)){
					this.openGallery(img, e);
				} else {
					this.openLightbox(img.cloneNode(true), e, 'hide');
				}
      })
		);

		this.lightbox.addEventListener('click', e => {
			this.closeLightbox(e.target);
		});

		document.addEventListener('keydown', (evt) => {
      evt = evt || window.event;
      var isEscape = false;
      if ('key' in evt) {
        isEscape = evt.key === 'Escape' || evt.key === 'Esc';
      } else {
        isEscape = evt.keyCode === 27;$
      }
      if (isEscape) {this.closeLightbox(evt.target);
      }
		});

	}

	openLightbox(img, e, navDisplay){
		img.classList.remove('ns-img--full');
		img.classList.remove('ns-img--small');
		img.classList.remove('ns-img--portrait');
		this.lightboxImgWrap.innerHTML = '';
		this.lightbox.classList.remove('js-lightbox--hidden');
		setTimeout(() => {
			this.lightbox.classList.add('js-lightbox--visible');
		}, 300);
		this.lightboxImgWrap.appendChild(img);

		this.navDisplay(navDisplay);
	}

	openGallery(img, e){
		let prev = img.previousSibling;
		let next = img.nextSibling;

		if(prev && next){
			this.openLightbox(img.cloneNode(true), e, 'show');
		} else if(prev){
			this.openLightbox(img.cloneNode(true), e, 'show prev');
		} else if(next){
			this.openLightbox(img.cloneNode(true), e, 'show next');
		} else {
			this.openLightbox(img.cloneNode(true), e, 'hide');
		}

		if(prev){
			this.registerClick(this.lightboxPrev, prev);
		}

		if(next){
			this.registerClick(this.lightboxNext, next);
		}
	}

	registerClick(el, img){
		el.addEventListener('click', e => {
			this.openGallery(img, e);
		});
	}

	navDisplay(action){
		if(action == 'hide'){
			this.lightboxNext.classList.add('lightbox__nav--hidden');
			this.lightboxPrev.classList.add('lightbox__nav--hidden');
		}

		if(action == 'show'){
			this.lightboxNext.classList.remove('lightbox__nav--hidden');
			this.lightboxPrev.classList.remove('lightbox__nav--hidden');
		}

		if((action == 'show prev') || (action == 'hide next')){
			this.lightboxNext.classList.add('lightbox__nav--hidden');
			this.lightboxPrev.classList.remove('lightbox__nav--hidden');
		}

		if((action == 'show next') || (action == 'hide prev')){
			this.lightboxNext.classList.remove('lightbox__nav--hidden');
			this.lightboxPrev.classList.add('lightbox__nav--hidden');
		}
	}

	closeLightbox(target) {
		if(target.tagName != 'SPAN'){
			this.lightboxImgWrap.innerHTML = '';
			this.lightbox.classList.remove('js-lightbox--visible');
			setTimeout(() => {
				this.lightbox.classList.add('js-lightbox--hidden');
			}, 300);
		}
	}
}

export default Lightbox;
